import React from 'react';
import { Chip, Avatar, Typography, Box } from '@mui/material';

interface IncidentCommanderPillProps {
  photoUrl?: string;
  assignment: string;
  name: string;
}

const IncidentCommanderPill: React.FC<IncidentCommanderPillProps> = ({
  photoUrl,
  assignment,
  name
}) => (
  <Chip
    avatar={<Avatar src={photoUrl} alt={name} sx={{ width: 28, height: 28 }} />}
    label={
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: 0.25,
          ml: 1
        }}>
        <Typography variant="caption" sx={{ fontWeight: 600, lineHeight: 1 }}>
          {assignment}
        </Typography>
        <Typography variant="caption" sx={{ lineHeight: 1 }}>
          {name}
        </Typography>
      </Box>
    }
    sx={{
      height: 40,
      background: '#E3F2FD', // Doesn't match design
      '.MuiChip-label': {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 1,
        paddingRight: 1,
        paddingLeft: 0
      },
      mr: 0,
      mb: 1,
      fontSize: 14,
      width: 'fit-content',
      minWidth: 0,
      maxWidth: '100%'
    }}
  />
);

export default IncidentCommanderPill;
